export default {
  home: {
    hero: {
      title: 'Kamera sigurie dhe sisteme alarmi për privatë dhe biznese',
      subtitle: 'SSG Signaltechnik planifikon, instalon dhe mirëmban sisteme moderne të vëzhgimit me video dhe sisteme alarmi në të gjithë rajonin Rhein-Main – nga Hainburg, përmes Offenbach, Frankfurt dhe Hanau, deri në Darmstadt dhe Groß-Gerau. Përshtatur individualisht me pronën tuaj, kërkesat tuaja dhe zonat që duhen mbrojtur vërtet.',
      ctaPrimary: 'Kërkoni një konsultim të parë falas',
      ctaSecondary: 'Nisni planifikuesin e kamerave',
    },
    trust: {
      '0': 'Planifikim individual',
      '1': 'Instalim profesional',
      '2': 'Konfigurim i aplikacionit',
      '3': 'Kujdes personal',
      '4': 'Privatë dhe biznese',
    },
    service: {
      eyebrow: 'Qasja jonë',
      title: 'Më shumë se thjesht montimi i kamerave',
      lead: 'Çdo pronë është e ndryshme. Prandaj e studiojmë me kujdes situatën tuaj përpara se të propozojmë një kamerë të vetme. Shërbimi i plotë përfshin:',
      steps: {
        '0': 'Analiza e nevojave dhe pronës',
        '1': 'Zgjedhja e llojit të kamerës dhe këndit të shikimit',
        '2': 'Kontrolli i pikave të mundshme të verbëra',
        '3': 'Planifikimi i kabllove, rrjetit dhe regjistrimit',
        '4': 'Montim dhe orientim profesional',
        '5': 'Konfigurimi i aplikacionit dhe qasjes në distancë',
        '6': 'Udhëzim i qartë i klientit',
        '7': 'Mirëmbajtje e vazhdueshme e sistemit sipas dëshirës',
      },
      more: 'Zbuloni të gjitha shërbimet',
    },
    solutions: {
      eyebrow: 'Llojet e pronave',
      title: 'Zgjidhje për çdo pronë',
      lead: 'Qoftë shtëpi, dyqan apo sallë prodhimi – gjejmë zgjidhjen e duhur për kërkesat tuaja.',
      filter: { alle: 'Të gjitha', privat: 'Privat', gewerbe: 'Biznes', innen: 'Brenda', aussen: 'Jashtë', neu: 'Sistem i ri' },
      more: 'Mëso më shumë',
      viewAll: 'Shiko të gjitha zgjidhjet',
    },
    area: {
      eyebrow: 'Zona e shërbimit',
      title: 'Kamera sigurie dhe alarme në të gjithë rajonin Rhein-Main',
      lead: 'Nga selia jonë në Hainburg mbulojmë të gjithë zonën metropolitane: Frankfurt, Offenbach, Hanau, Darmstadt, Groß-Gerau dhe të gjitha komunat përreth. Planifikim, instalim dhe mirëmbajtje e kamerës ose alarmit tuaj – gjithmonë personalisht dhe në vend.',
      viewAll: 'Shiko të gjitha zonat e shërbimit',
    },
    tech: {
      eyebrow: 'Planifikim teknik',
      title: 'Teknologjia e duhur për qëllimin e duhur',
      lead: 'Nuk kanë rëndësi vetëm megapikselët. Një sistem i mirë kamerash lind nga kombinimi i shumë faktorëve.',
      points: {
        '0': { title: 'I brendshëm ose i jashtëm', desc: 'Lagështia, moti dhe temperatura përcaktojnë zgjedhjen e kamerës.' },
        '1': { title: 'Drita dhe kushtet e natës', desc: 'Zgjidhje ditë/natë dhe me dritë të ulët për çdo situatë ndriçimi.' },
        '2': { title: 'Pamje e përgjithshme ose detaje', desc: 'Kënd i gjerë për pamjen e plotë ose telefoto për fytyra dhe targa.' },
        '3': { title: 'Distanca dhe lartësia e montimit', desc: 'Sa më lart e më larg, aq më shumë rezolucion dhe objektiv më i mirë nevojitet.' },
        '4': { title: 'Këndi i shikimit dhe objektivi', desc: 'Gjatësi fokale fikse, varifokale ose e motorizuar, sipas qëllimit.' },
        '5': { title: 'Regjistrimi dhe ruajtja', desc: 'Regjistrues lokal me ruajtje në disk sipas nevojës.' },
        '6': { title: 'Qasja përmes aplikacionit', desc: 'Pamje live dhe rishikim përmes telefonit, sipas sistemit.' },
        '7': { title: 'Njoftimet e ngjarjeve', desc: 'Mesazhe push te lëvizjet ose ngjarjet e përcaktuara, sipas sistemit.' },
        '8': { title: 'Zgjerueshmëria', desc: 'Sistemet ekzistuese zakonisht mund të zgjerohen me kamera shtesë.' },
      },
    },
    process: {
      eyebrow: 'Rrjedha',
      title: 'Si ecën projekti juaj',
      lead: 'Nga kërkesa e parë deri te sistemi i përfunduar – në mënyrë transparente dhe personale.',
      steps: {
        '0': { title: 'Biseda e parë', desc: 'Diskutojmë nevojat tuaja, pronën dhe zonat që dëshironi të monitoroni.' },
        '1': { title: 'Vizita dhe planifikimi', desc: 'Takim në vend për të analizuar dritën, këndet, pikat e montimit dhe kabllot.' },
        '2': { title: 'Ofertë individuale', desc: 'Merrni një ofertë transparente me teknologjinë e duhur dhe fushëveprim të qartë.' },
        '3': { title: 'Instalimi dhe konfigurimi', desc: 'Montim profesional, lidhje rrjeti, konfigurim i regjistruesit dhe aplikacionit.' },
        '4': { title: 'Udhëzimi dhe kujdesi', desc: 'Mësoni të përdorni sistemin. Jemi pranë jush – edhe më pas.' },
      },
    },
    refs: {
      eyebrow: 'Projekte referimi',
      title: 'Projekte të realizuara',
      lead: 'Një përzgjedhje nga portofoli ynë – nga pronat private te sistemet e biznesit.',
      viewAll: 'Zbuloni të gjitha zgjidhjet',
      items: {
        '0': { label: 'Shtëpi private – banesë familjare', desc: 'Sistem i plotë me 6 kamera, NVR dhe lidhje me aplikacionin' },
        '1': { label: 'Tregti – butik', desc: 'Sipërfaqja e shitjes dhe magazina me 4 kamera dhe shikim natën' },
        '2': { label: 'Logjistikë – magazinë', desc: 'Mbikëqyrje e sipërfaqeve të mëdha me kënd të gjerë dhe PTZ' },
        '3': { label: 'Klinikë – recepsion mjekësor', desc: 'Mbikëqyrje e brendshme diskrete me maskim të privatësisë' },
        '4': { label: 'Pasuri e paluajtshme – pallat', desc: 'Hyrja dhe zonat e jashtme me tabela informuese' },
      },
    },
    care: {
      eyebrow: 'Mirëmbajtje dhe kujdes',
      title: 'SSG Care',
      lead: 'Teknologjia juaj e kamerave duhet të funksionojë me besueshmëri në afat të gjatë. Me SSG Care merrni një abonim fleksibël kujdesi – me anulim mujor ose me afat të rënë dakord.',
      list: {
        '0': 'Kontrolle të rregullta të sistemit dhe përditësime të firmuerit',
        '1': 'Mbështetje për problemet e aplikacionit dhe qasjes',
        '2': 'Ndihmë gjatë ndërrimit të telefonit',
        '3': 'Kontroll i regjistrimit dhe ruajtjes',
        '4': 'Përpunim me përparësi sipas marrëveshjes',
      },
      cta: 'Zbuloni SSG Care',
    },
    planner: {
      eyebrow: 'Mjet interaktiv',
      title: 'Planifikuesi i kamerave SSG',
      lead: 'Vizatoni dhoma ose sipërfaqe, shënoni zonat e rëndësishme të mbikëqyrjes dhe provoni pozicionet e mundshme të kamerave me kone shikimi. Rezultati është një plan paraprak jo-detyrues për bisedën tuaj me ne.',
      list: {
        '0': 'Vizatimi i dhomave dhe mureve',
        '1': 'Vendosja e ikonave të kamerave me tërheqje',
        '2': 'Kone shikimi rrotulluese me vlerësim të mbulimit',
        '3': 'Shënimi i zonave të mbikëqyrjes dhe privatësisë',
        '4': 'Dërgimi i rezultatit si kërkesë ose printimi i tij',
      },
      cta: 'Nisni planifikuesin e kamerave',
    },
    faq: {
      eyebrow: 'Pyetje të shpeshta',
      title: 'Çfarë na pyesin shpesh klientët',
      viewAll: 'Shiko të gjitha pyetjet',
      items: {
        '0': { question: 'Sa kamera më duhen?', answer: 'Varet nga madhësia e pronës, zonat që duhen monitoruar dhe niveli i dëshiruar i detajeve. Pas bisedës së parë dhe vizitës, hartojmë një propozim individual.' },
        '1': { question: 'A mund t’i shoh kamerat në telefon?', answer: 'Po, me shumicën e sistemeve moderne është i mundur qasja përmes aplikacionit. Ne e konfigurojmë lidhjen e aplikacionit drejtpërdrejt gjatë instalimit.' },
        '2': { question: 'A funksionojnë kamerat në errësirë?', answer: 'Po, për zonat e jashtme dhe ambientet me ndriçim të dobët ka kamera speciale ditë/natë dhe me dritë të ulët me shikim nate infra të kuqe ose me ngjyra.' },
        '3': { question: 'Sa kushton një sistem kamerash?', answer: 'Kostoja varet nga numri i kamerave, prona, kabllot dhe fushëveprimi i dëshiruar i funksioneve. Me kënaqësi hartojmë një ofertë individuale dhe jo-detyruese.' },
      },
    },
    cta: {
      title: 'Le të zbulojmë së bashku se cila zgjidhje i përshtatet pronës suaj.',
      lead: 'Na telefononi, na shkruani ose nisni drejtpërdrejt planifikuesin e kamerave. Do t’ju përgjigjemi shpejt.',
      primary: 'Kërkoni një konsultim të parë falas',
      secondary: 'Nisni planifikuesin e kamerave',
    },
  },
  company: {
    solutions: {
      home: { title: 'Shtëpia dhe oborri', description: 'Nga dera e hyrjes deri te garazhi – mbikëqyrje diskrete për shtëpinë tuaj.' },
      retail: { title: 'Tregtia dhe gastronomia', description: 'Zona e arkës, hyrja dhe magazina – të siguruara profesionalisht.' },
      office: { title: 'Zyra dhe klinika', description: 'Recepsioni, korridoret dhe zonat e ndjeshme – të planifikuara me respekt për privatësinë.' },
      warehouse: { title: 'Magazina dhe logjistika', description: 'Mbikëqyrje e sipërfaqeve të mëdha me kënd të gjerë dhe shikim natën.' },
      workshop: { title: 'Punishtja dhe zejtaria', description: 'Kamera të qëndrueshme për mjedise më të vështira – salla dhe zona të jashtme.' },
      apartment: { title: 'Pallatet dhe pronat', description: 'Hyjet, shkallët dhe zonat e jashtme – për qiramarrësit dhe pronarët.' },
    },
  },
};